import { render, staticRenderFns } from "./PostApprove.vue?vue&type=template&id=39aae0fc&scoped=true"
import script from "./PostApprove.vue?vue&type=script&lang=js"
export * from "./PostApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aae0fc",
  null
  
)

export default component.exports